import { createAction } from '@reduxjs/toolkit';

const CONFIGURATIONS_TYPE = 'configurations';

export const configurationsActions = {
  initConfigurations: createAction(`${CONFIGURATIONS_TYPE}/initConfigurations`),
};
